import { useEffect, useState } from "react";

export type ResponsiveSidebarMode = "wide" | "narrow-desktop" | "touch";

const NARROW_DESKTOP_MAX_WIDTH = 900;
const TOUCH_MAX_WIDTH = 640;

function readResponsiveSidebarMode(): ResponsiveSidebarMode {
  if (typeof window === "undefined" || window.innerWidth > NARROW_DESKTOP_MAX_WIDTH) return "wide";
  if (window.innerWidth <= TOUCH_MAX_WIDTH) return "touch";
  const finePointer = window.matchMedia("(pointer: fine)").matches;
  const hover = window.matchMedia("(hover: hover)").matches;
  return finePointer && hover ? "narrow-desktop" : "touch";
}

export function useResponsiveMode() {
  const [mode, setMode] = useState<ResponsiveSidebarMode>(readResponsiveSidebarMode);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        setMode(readResponsiveSidebarMode());
      });
    };
    const capabilityQueries = [
      window.matchMedia("(pointer: fine)"),
      window.matchMedia("(hover: hover)")
    ];
    window.addEventListener("resize", update);
    capabilityQueries.forEach((query) => query.addEventListener("change", update));
    return () => {
      window.removeEventListener("resize", update);
      capabilityQueries.forEach((query) => query.removeEventListener("change", update));
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return mode;
}
